export enum SignalRMethods {
    JoinGroup = 'JoinGroup',
    LeaveGroup = 'LeaveGroup',
}
